import React, { useState, useEffect, useMemo } from 'react';

import { useHistory } from "react-router-dom";

import { Button } from '@shadcn/components/ui/button'
import { Card, CardContent as CardBody} from '@shadcn/components/ui/card'
import { Row } from '@shadcn/components/ui/row'
import { Col } from '@shadcn/components/ui/col'
import useQuery from '../../helpers/JIFI/useQuery';

//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';

import queryString from 'query-string';

import superagent from 'superagent'
import {backendUrl} from '../../helpers/consts.js'
import { ToastContainer, toast } from 'react-toastify'
import {
    filterApprovalsForStatus,
    groupApprovalsForReview,
    hasUnreviewedPendingApprovals,
} from './approval-group.utils'

const getApprovalErrorMessage = (error) => {
    const message = error?.response?.body?.message
        || error?.response?.body?.response?.message
        || error?.message

    return Array.isArray(message)
        ? message.join(', ')
        : message || 'Failed to submit approval'
}

const numberWithSign = (number) => {
    let signed = ''
    const positive = number > 0
    if(positive){
        signed += '+'
    }
    signed += number
    return <span className={`text-${positive || number === 0 ? 'success' : 'danger'}`}> {signed} </span>
} 

const ApprovalsBadge = ({status}) => {
    const statuses = {
        'pending': 'warning',
        'processing': 'info',
        'shopify_failed': 'danger',
        'approved': 'success',
        'rejected': 'danger'
    }
    const label = status === 'shopify_failed' ? 'Shopify failed' : status
    return <span style={{fontSize: 8}} className={`ml-2 badge badge-${statuses[status]}`}>{label}</span>
}

const ProjectsList = ({
    location
}) => {
    let params = queryString.parse(location.search);
    const [refresh, setRefresh] = useState(false)
    const [loadingSend, setLoadingSend] = useState(true)
    const refreshData = () => setRefresh(prev => !prev)
    const [data, state] = useQuery({
        url: `/inventory/approvalGroupOne`,
        queryData: {
            date: params['date'],
            location: params['location']
        },
        refresh
    });

    const approvals = data && data.data

    // Collapse duplicate pending approvals for the same product into one card.
    // Terminal audits are display-only and must never be resubmitted in staleIds.
    const groupedApprovals = useMemo(
        () => filterApprovalsForStatus(
            groupApprovalsForReview(approvals),
            params['status']
        ),
        [approvals, params['status']]
    )

    const [productData, productState] = useQuery({
        url: `/product`
    });
    const products = productData && productData.data
    const variants = products?.map(product => product.variants).flat()

    const history = useHistory();

    const [selectedApproval, setSelectedApproval] = useState(undefined)
    const handleChangeSelected = (key, val) => {
        setSelectedApproval(prev => {
            let newVal = [...prev]
            newVal[key] = val
            return newVal
        })
    }
    const handleSubmit = () => {
        if (loadingSend === false) {
            const hasUnreviewedApproval = hasUnreviewedPendingApprovals(
                groupedApprovals,
                selectedApproval
            )
            if (hasUnreviewedApproval) {
                toast.warning('Please accept or reject every pending audit before submitting')
                return
            }

            setLoadingSend(true)
            let ids = {
                accept: [],
                reject: []
            }
            selectedApproval.map((val, id) => {
                const group = groupedApprovals[id]
                if (val === true) {
                    ids.accept.push(group._id)            // approve the latest count
                    ids.reject.push(...group.staleIds)    // discard older duplicates
                } else if (val === false) {
                    ids.reject.push(group._id, ...group.staleIds)
                }
            })
    
            superagent.post(`${backendUrl}/inventory/multipleApprovals`)
                .send(ids)
                .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
                .set('accept', 'json')
                .then(() => {
                    history.go(0)
                    setLoadingSend(false)
                })
                .catch(error => {
                    const code = error?.status || error?.response?.status
                    if (code === 401 || code === 404) {
                        history.replace(history.location.pathname, {
                            errorStatusCode: code
                        })
                    }
                    toast.error(getApprovalErrorMessage(error))
                    setLoadingSend(false)
                })
        }
    }
    const retryShopifyApproval = (approvalId) => {
        setLoadingSend(true)
        superagent.post(`${backendUrl}/inventory/retryShopifyApprovals`)
            .send({ approvalIds: [approvalId] })
            .set('Authorization', `Bearer ${localStorage.getItem("authJWT")}`)
            .set('accept', 'json')
            .then(() => history.go(0))
            .catch(error => {
                toast.error(getApprovalErrorMessage(error))
                setLoadingSend(false)
            })
    }
    useEffect(() => {
        if (groupedApprovals) {
            setSelectedApproval(groupedApprovals.map((val) => val.status !== 'pending' ? undefined : null))
            setLoadingSend(false)
        }
    }, [groupedApprovals])

    const hasUnreviewedApproval = hasUnreviewedPendingApprovals(
        groupedApprovals,
        selectedApproval
    )

    return (
        <>
            <ToastContainer position="top-right" autoClose={5000} />
            <div className="page-content">
            <div className="w-full px-3 mx-auto xl:max-w-[85%] mb-10">
                    <Breadcrumbs title="Inventory" breadcrumbItem={`${data?.location?.name || ''} Approvals - ${params['date']}`} />
                    {
                        (
                            groupedApprovals === undefined ||
                            (
                                groupedApprovals &&
                                    (groupedApprovals.filter(val => val.status === 'pending').length > 0))
                            ) && (
                            <Button disabled={loadingSend || hasUnreviewedApproval} onClick={handleSubmit} variant="success" style={{position: 'fixed', right: 96, bottom: 48, paddingLeft: 48, paddingRight: 48, zIndex: 99}} className={`btn-lg btn-rounded btn btn-success px-6 ${loadingSend || hasUnreviewedApproval ? 'disabled' : ''}`}>
                                {loadingSend ? (groupedApprovals === undefined ? 'Loading Audits...' : 'Submitting...') : 'Submit'}
                            </Button>
                        )
                    }
                    {
                        groupedApprovals && products ? groupedApprovals.map((data, approvalKey) => {
                            const count = data.count
                            const virtual_count = data.virtual_count
                            return (
                                <Card className="mt-4">
                                    <CardBody className="pt-6">
                                        <Row className="ml-2" style={{display: 'flex', alignItems: 'center'}}>
                                            <h3 className='text-[23px] font-medium' style={{marginBottom: 0}}> {products.find(val => `${data.product}` === `${val._id}`)?.name} Count </h3> <ApprovalsBadge status={data.status} />
                                            {data.status === 'shopify_failed' && (
                                                <Button className="ml-3" variant="outline" disabled={loadingSend} onClick={() => retryShopifyApproval(data._id)}>
                                                    Retry Shopify
                                                </Button>
                                            )}
                                        </Row>
                                        <Row>
                                            <Col>
                                                <div className="">
                                                    <div className="table-responsive">
                                                        <table className="project-list-table table-nowrap table-centered table-borderless">
                                                            <thead>
                                                                <tr>
                                                                    <th>SKU</th>
                                                                    <th>Stock On Hand</th>
                                                                    <th>Display Stock</th>
                                                                    <th>Dead Stock</th>
                                                                    <th>Comment</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                        count && Object.keys(count).map((sku, key) => {
                                                                            let line = count[sku]
                                                                            const virtualLine = virtual_count?.[sku] || { on_hand: 0, display: 0, dead: 0 }
                                                                            return (
                                                                                <tr>
                                                                                    <td> { sku } </td>
                                                                                    <td> {(line.on_hand !== undefined && line.on_hand !== null) ? <>{line.on_hand} {numberWithSign(line.on_hand - virtualLine.on_hand)}</> : 'None'}</td>
                                                                                    <td> {(line.display !== undefined && line.display !== null) ? <>{line.display} {numberWithSign(line.display - virtualLine.display)}</> : 'None'}</td>
                                                                                    <td> {(line.dead !== undefined && line.dead !== null) ? <>{line.dead} {numberWithSign(line.dead - virtualLine.dead)}</> : 'None'}</td>
                                                                                    <td> {line.comment}</td>
                                                                                </tr>
                                                                        )
                                                                    })
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </Col>
                                        </Row>
                                        {
                                            data.status === 'pending' && (
                                                <Row className="mb-2">
                                                    <Col className="sm:w-11/12">
                                                        <div className="btn-group btn-group-toggle" data-toggle="buttons" >
                                                            <label className={ selectedApproval?.[approvalKey] === true ? "btn btn-success active" : "btn btn-outline-success" } >
                                                                <input
                                                                    type="radio"
                                                                    name={`approval-${data._id}`}
                                                                    checked={selectedApproval?.[approvalKey] === true}
                                                                    onChange={() => handleChangeSelected(approvalKey, true) }
                                                                />
                                                                Accept
                                                            </label>
                                                            <label className={ selectedApproval?.[approvalKey] === false ? "btn btn-danger active" : "btn btn-outline-danger" } >
                                                                <input
                                                                    type="radio"
                                                                    name={`approval-${data._id}`}
                                                                    checked={selectedApproval?.[approvalKey] === false}
                                                                    onChange={() => handleChangeSelected(approvalKey, false) }
                                                                />
                                                                Reject
                                                            </label>
                                                        </div>
                                                    </Col>
                                                </Row>
                                            )
                                        }
                                    </CardBody>
                                </Card>
                            )
                        }) : (
                            <>
                                <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', padding: 48 }}>
                                    <div className="spinner-grow text-primary m-1" role="status">
                                    <span className="sr-only">Loading...</span>
                                    </div>
                                </div>

                            </>
                        )
                    }
                </div>
            </div>
        </>
    );
}

export default ProjectsList;
